import gql from "graphql-tag"

const fragment = gql`
  fragment fullDealOrder on DealOrder {
    uuid
    total {
      value
      currency
    }
    totalSavings {
      value
      currency
    }
    totalBeforeDiscount {
      value
      currency
    }
    totalVAT {
      value
      currency
    }
    products {
      productId
      quantity
      name
      items {
        uuid
        product
        type
        usage
        code
        pin
        expiry
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
